import type { ComponentProps, FC } from 'react';

import { Button } from '@repo/ui/components/common';
import { cn } from '@repo/utils/common';

interface OutlineButtonProps extends Omit<ComponentProps<typeof Button>, 'variant'> {
  className?: string;
}

export const OutlineButton: FC<OutlineButtonProps> = ({ children, className, ...props }) => {
  return (
    <Button
      className={cn(
        'rounded-[3px] border-white bg-white/5 text-white backdrop-blur-sm focus-visible:border-white/50 focus-visible:ring-white/50',
        className,
      )}
      variant="outline"
      {...props}
    >
      {children}
    </Button>
  );
};
